import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {MonitoredChannel, MonitoredChannelSource} from "../../models/monitoredChannel";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";

export class MonitoredChannelDao extends BaseDao {
    constructor(apiHelper: ApiHelper, private httpClient: HttpClient) {
        super(ConstantMan.API.RESOURCE.MONITOREDCHANNELS, apiHelper);
    }

    public load(): Observable<any> {
        // Use the default load method - it will work for both monitoredchannels and monitoredchannelaudits
        return super.load();
    }

    deleteBySource(source: MonitoredChannelSource) {
        let url = this.apiHelper.getServiceName() + this.getResource() + `/${source}`;
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'DELETE', null, null, headers);
    }

    createKantar(channels: MonitoredChannel | MonitoredChannel[]) {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/kantar';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, channels, headers);
    }

    createWWTV(channels: MonitoredChannel | MonitoredChannel[]) {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/wwtv';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, channels, headers);
    }

    uploadCsv(file: File, csvType: string = 'auto'): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        // Build URL with query parameter
        let url = this.apiHelper.getServiceName() + this.getResource() + '/upload-csv';
        const params = new HttpParams().set('type', csvType);

        // Get authorization header but don't set Content-Type (browser will set it with boundary for multipart/form-data)
        const token = this.apiHelper.getAccessToken();
        let headers = new HttpHeaders();
        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }
        // Explicitly do NOT set Content-Type - browser will set it with boundary

        return this.httpClient.post(url, formData, {
            headers: headers,
            params: params
        });
    }
}